var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.703,
    height: 45.966,
    viewBox: "0 0 45.703 45.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "revenue",
    transform: "translate(0 0.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215487",
    "data-name": "Path 215487",
    d: "M145.1,12.14A12.051,12.051,0,1,0,133.051,24.19,12.141,12.141,0,0,0,145.1,12.14Zm-13.39,8.034V18.985a4.009,4.009,0,0,1-2.692-3.775,1.339,1.339,0,0,1,2.678,0,1.339,1.339,0,1,0,1.339-1.339,4.007,4.007,0,0,1-1.325-7.791V4.106a1.339,1.339,0,0,1,2.678,0V6.088a4.011,4.011,0,0,1,2.664,3.766,1.339,1.339,0,0,1-2.678,0,1.339,1.339,0,1,0-1.339,1.339,4.007,4.007,0,0,1,1.353,7.783v1.2a1.339,1.339,0,0,1-2.678,0Zm0,0",
    transform: "translate(-110.199)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215488",
    "data-name": "Path 215488",
    d: "M1.339,311.276l7.909-.027c.239.04,12.761,2.313,15.534,2.775a1.292,1.292,0,0,0,.97-.217c3.016-2.112,20.6-14.544,19.389-13.7a1.354,1.354,0,0,0,.321-1.875,4.046,4.046,0,0,0-5.6-.964c-.268.187-13.286,9.226-12.461,8.65H17.5a1.339,1.339,0,1,1,0-2.678h8.034a2.678,2.678,0,0,0,0-5.356h-1.66a1.332,1.332,0,0,1-.884-.321,10.7,10.7,0,0,0-3.723-2.356c-6.081-2.15-9.942,2.485-10.31,2.678H1.339A1.339,1.339,0,0,0,0,299.225v10.716A1.335,1.335,0,0,0,1.339,311.276Zm0,0",
    transform: "translate(0 -268.34)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_890",
    "data-name": "Ellipse 890",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(11.118 -0.263)",
    fill: "#00057d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(17.118 18.737)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats2);
export default __webpack_public_path__ + "static/media/stats2.f57363a30d14ee20ab96687d6fb3c1b5.svg";
export { ForwardRef as ReactComponent };